import SecondaryMenu from "./SecondaryMenu";

export default SecondaryMenu;
